import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
 async createApproval(data){
  //
    let response = await apiCall("approvals/create", data)
    return response;
  },
  async fetchApproversPendingApprovalsList(data) {
    let response = await apiCall("approvals/getting_user_pending_approval_requisitions", data)
    return response;
  },
  async fetchApprovals(data) {
    let response = await apiCall("approvals/get_user_approvals", data)
    return response;
  },
  async getRequisitionDetailsAndApprovalDetails(data) {
    let response = await apiCall("approvals/get_requisition_approval_details", data)
    return response;
  },
  async updateApprovalLevel(data) {
    let response = await apiCall("requisitions/update_approval_level_requisition", data)
    return response;
  },
}